module.exports = __webpack_public_path__ + "img/documents-black.65435831.svg";